<template>
    <el-dialog title :visible.sync="dialogVisible" width="900px">
        <div class="header">
            <h1>{{temp.title}}</h1>
            <div class="basic">
                <p>{{ temp.author }}</p>
                <p>{{ temp.release_time }}</p>
                <el-tag type="warning" v-if="temp.source">
                    <router-link target="_blank" :to="temp.link">{{sourceOptions[temp.source]}}</router-link>
                </el-tag>
            </div>
            <div class="school">
                <p>{{temp.school_name}}</p>
                <p>{{temp.major_name}}</p>
            </div>
        </div>
        <div class="content" v-html="temp.content"></div>
        <div class="tag" v-if="label.length > 0">
            <el-tag v-for="(item, i) in label" :key="i">{{item}}</el-tag>
        </div>
    </el-dialog>
</template>
<script>
import checkPermission from "@/utils/permission";
import { getDetail } from "@/api/article";

export default {
    name: "Detail",
    data() {
        return {
            uuid: "",
            dialogVisible: false,
            temp: {},
            sourceOptions: [
                "",
                "百度贴吧",
                "考研帮",
                "小红书",
                "知乎",
                "豆瓣",
                "微博",
                "百度知道",
                "简书"
            ],
            label: []
        };
    },
    created() {},
    methods: {
        checkPermission,

        // 详情
        handleDetail(uuid) {
            getDetail(uuid).then(res => {
                this.temp = res.data;
                let label = res.data.label.replace("，", ",");
                this.label =
                    res.data.label === "" ? res.data.label : label.split(",");
                this.dialogVisible = true;
            });
        }
    }
};
</script>
<style lang="less" scope>
p {
    margin: 0;
    padding: 0;
}
.header {
    h1 {
        margin: 0;
        font-size: 24px;
    }
    .basic {
        display: flex;
        color: #909399;
        margin: 20px 0;
        p {
            margin-right: 20px;
            line-height: 28px;
        }
    }
    .school {
        display: flex;
        p {
            margin: 0 20px;
            line-height: 28px;
        }
    }
}
.content {
    border: 1px solid #f2f6fc;
    padding: 20px;
    margin: 20px 0;
    p {
        line-height: 1.5;
    }
    img {
        max-width: 100%;
    }
}
.tag {
    .el-tag {
        margin-right: 10px;
    }
}
</style>